<template>
    <checker-detail-row>
        <div slot="left">
            <span v-if="rental === 'short'">Total Cost</span>
            <span v-else>Monthly Cost</span>
        </div>
        <div slot="right">
            <template v-if="seasonIntervalData">
                <strong class="text-green">&pound;{{ seasonIntervalData.cost.per_month | currencyFormat }}</strong>
            </template>
            <template v-else-if="isQuoteValueValid">
                <span class="text-green">&pound;{{ quote.value | currencyFormat }}</span>
            </template>
            <template v-else>
                <span v-if="rental === 'short'" class="text-green">&pound;{{ space.price_matrix.daily | currencyFormat }}</span>
                <span v-else class="text-green">&pound;{{ space.price_matrix.monthly | currencyFormat }}</span>
            </template>
        </div>
    </checker-detail-row>
</template>

<script>
    import CheckerDetailRow from '../CheckerDetailRow';
    import { mapGetters } from 'vuex';

    export default {
        name: 'cost-row',

        components: { CheckerDetailRow },

        props: {
            rental: {
                type: String,
                default() {
                    return '';
                },
            },

            space: {
                type: Object,
                default() {
                    return {};
                },
            },

            quote: {
                type: Object,
                default() {
                    return {};
                },
            },
        },

        computed: {
            ...mapGetters('booking', [
                'seasonIntervalData',
            ]),

            /**
             * Returns true if the quote value is 0 or greater.
             *
             * @returns {boolean}
             */
            isQuoteValueValid() {
                return this.quote.value >= 0;
            },
        },
    };
</script>
